import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import bp from 'styled-components-breakpoint';
import Button from 'components/Button';
import Logo from 'components/Logo';
import BookBike from 'components/BookBike';
import { Menu, X } from 'components/Icons';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${bp('tablet')`
    display: none
  `};
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: row;
  width: 50%;
`;

const StyledHamburgerButton = styled(Button)`
  &:focus:enabled,
  &:active:enabled {
    border: 0;
    box-shadow: none;
    outline: 0;
  }
`;

const StyledLogo = styled(Logo)`
  height: 100%;
  margin-left: 0.25rem;
  padding: 0;
  width: 6.75rem;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const RightColumn = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  width: 50%;
`;

const StyledBookBike = styled(BookBike)`
  margin-right: 0.5rem;
`;

function HeaderMobile({
  id,
  isOpen,
  LinkWrapper,
  menuButtonClick,
  showSecondaryButton,
  showLogo,
  ...rest
}) {
  return (
    <HeaderContainer id={id} {...rest}>
      <LeftColumn>
        <StyledHamburgerButton
          id={`${id}-control`}
          text="Open Menu"
          variation="flat"
          icon={isOpen ? X : Menu}
          onClick={menuButtonClick}
        />
        {showLogo ? (
          <StyledLogo
            id={`${id}-logo`}
            ariaLabel="SoulCycle Home Page"
            LinkWrapper={LinkWrapper}
          />
        ) : null}
      </LeftColumn>
      <RightColumn>
        {showSecondaryButton ? <StyledBookBike id={`${id}-book-bike`} /> : null}
      </RightColumn>
    </HeaderContainer>
  );
}

HeaderMobile.propTypes = {
  /**
   * id attribute for the header
   */
  id: PropTypes.string,
  /**
   * state of the mobile pane
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Link component wrapper
   */
  LinkWrapper: PropTypes.func,
  /**
   * Function to handle the menu button click
   */
  menuButtonClick: PropTypes.func.isRequired,
  /**
   * show or hide the secondary button
   */
  showSecondaryButton: PropTypes.bool,
  /**
   * show or hide the logo
   */
  showLogo: PropTypes.bool,
};

HeaderMobile.defaultProps = {
  id: 'header-mobile',
  LinkWrapper: null,
  showLogo: true,
  showSecondaryButton: true,
};

export default HeaderMobile;
